<template>
  <v-autocomplete
    v-if="variant === 'autocomplete'"
    v-model="modelValue"
    @update:search="handleSearchInput"
    :aria-label="ariaLabelResolved"
    :class="inputClass"
    :data-testid="dataTestid"
    :hide-no-data="hideNoData"
    :item-title="itemTitle"
    :item-value="itemValue"
    :items="items"
    :list-props="{ class: 'b-1 bc-very-light-gray' }"
    :loading="loading"
    :no-filter="noFilter"
    :placeholder="placeholder"
    base-color="#adadad"
    bg-color="#ffffff"
    density="compact"
    prepend-inner-icon="search"
    variant="outlined"
    clearable
    flat
    hide-details
    tracked
  />

  <!-- eslint-disable-next-line prefer-standard-components/no-vuetify-inputs -->
  <v-text-field
    v-else
    v-model="modelValue"
    :aria-label="ariaLabelResolved"
    :class="inputClass"
    :data-testid="dataTestid"
    :loading="loading"
    :placeholder="placeholder"
    base-color="#adadad"
    bg-color="#ffffff"
    density="compact"
    prepend-inner-icon="search"
    variant="outlined"
    clearable
    flat
    hide-details
    tracked
  />
</template>

<script setup>
const modelValue = defineModel({
  type: [String, Number, Object],
  default: null,
});

const props = defineProps({
  ariaLabel: {
    type: String,
    default: null,
  },
  dataTestid: {
    type: String,
    default: 'standard-search',
  },
  hideNoData: {
    type: Boolean,
    default: false,
  },
  inputClass: {
    type: String,
    default: 'mxw-400',
  },
  itemTitle: {
    type: String,
    default: 'title',
  },
  itemValue: {
    type: String,
    default: 'value',
  },
  items: {
    type: Array,
    default: () => [],
  },
  loading: {
    type: Boolean,
    default: false,
  },
  noFilter: {
    type: Boolean,
    default: false,
  },
  onSearchInput: {
    type: Function,
    default: null,
  },
  placeholder: {
    type: String,
    default: '',
  },
  variant: {
    type: String,
    default: 'text',
    validator: (value) => ['text', 'autocomplete'].includes(value),
  },
});

const ariaLabelResolved = computed(() => props.ariaLabel || props.placeholder || 'Search');

function handleSearchInput(value) {
  props.onSearchInput?.(value);
}
</script>

<style scoped>
/* Match StandardButton min-height (WCAG 2.1 AAA touch target) so toolbar controls align. */
:deep(.v-field) {
  min-height: 3rem !important;
}

:deep(.v-field__field) {
  align-items: center;
}

@media (min-width: 48rem) {
  :deep(.v-field) {
    min-height: 2.75rem !important;
  }
}
</style>
